(function(){
    let all=[], loadedAll=false, loading=false, cardCache=new Map(), filtered=[], sortValue='', itemsPerPage=40, searchPage=1, renderToken=0;
    let originalPaginationHTML='';
    let countEls=[], originalCounts=[];
    const API_PAGE_LIMIT=250, MAX_PAGES=200, CONCURRENCY=6;

    function qs(sel,root){return (root||document).querySelector(sel)}
    function qsa(sel,root){return Array.from((root||document).querySelectorAll(sel))}
    function norm(s){try{return (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(_){return (s||'').toLowerCase()}}
    function stripHTML(s){return (s||'').replace(/<[^>]*>/g,' ')}
    function debounce(fn,ms){let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),ms||220)}}
    function minPrice(p){if(!p||!Array.isArray(p.variants)||!p.variants.length)return 1/0;let m=1/0;for(const v of p.variants){const n=Number(v.price);if(!isNaN(n)&&n<m)m=n}return isFinite(m)?m:1/0}
    function getHandle(){const m=location.pathname.match(/\/collections\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):''}
    function spinner(on){const s=qs('.loading__spinner');if(s)s.classList.toggle('hidden',!on)}
    function setNiceCurrent(nice,text){const c=nice&&nice.querySelector('.current');if(c)c.textContent=text}

    function applySort(arr){
        switch(sortValue){
            case 'title-ascending':arr.sort((a,b)=>(a.title||'').localeCompare(b.title||'',{sensitivity:'base'}));break
            case 'title-descending':arr.sort((a,b)=>(b.title||'').localeCompare(a.title||'',{sensitivity:'base'}));break
            case 'price-ascending':arr.sort((a,b)=>minPrice(a)-minPrice(b));break
            case 'price-descending':arr.sort((a,b)=>minPrice(b)-minPrice(a));break
            case 'created-ascending':arr.sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));break
            case 'created-descending':arr.sort((a,b)=>new Date(b.created_at)-new Date(a.created_at));break
            default:break
        }
    }

    async function fetchAll(){
        if(loading||loadedAll)return; loading=true; spinner(true);
        try{
            let page=1; const seen=new Set(all.map(p=>p.handle||p.id)), handle=getHandle();
            while(page<=MAX_PAGES){
                const u=`/collections/${encodeURIComponent(handle)}/products.json?limit=${API_PAGE_LIMIT}&page=${page}`;
                const res=await fetch(u,{headers:{Accept:'application/json'}});
                if(!res.ok)break;
                const data=await res.json(); const items=Array.isArray(data.products)?data.products:[];
                if(!items.length)break;
                for(const p of items){
                    if(typeof p.tags==='string')p.tags=p.tags.split(',').map(s=>s.trim()).filter(Boolean);
                    const key=p.handle||p.id; if(key&&!seen.has(key)){ seen.add(key); all.push(p)}
                }
                if(items.length<API_PAGE_LIMIT)break; page++
            }
            loadedAll=true
        }finally{loading=false; spinner(false)}
    }

    async function fetchCard(handle){
        if(cardCache.has(handle))return cardCache.get(handle);
        try{
            const res=await fetch(`/products/${encodeURIComponent(handle)}?view=card`,{headers:{Accept:'text/html'}});
            const html=res.ok?await res.text():'';
            cardCache.set(handle,html||''); return html||''
        }catch(_){cardCache.set(handle,'');return''}
    }

    function setModeSearch(on,$ourGrid,$stdGrid,$pagi){if(on){$ourGrid.classList.remove('hidden');$stdGrid.style.display='none'}else{$ourGrid.classList.add('hidden');$stdGrid.style.display=''}$pagi.style.display=''}

    function updateCount(){
        const total=Array.isArray(filtered)?filtered.length:0;
        const start=total?((searchPage-1)*itemsPerPage+1):0;
        const end=total?Math.min(searchPage*itemsPerPage,total):0;
        const txt=total?(`Showing ${end} of ${total} products`):'Showing 0 of 0 products';
        countEls.forEach(el=>{el.textContent=txt})
    }

    function restoreCount(){
        countEls.forEach((el,i)=>{el.innerHTML=originalCounts[i]??originalCounts[0]??''})
    }

    function restorePagi($pagi){$pagi.innerHTML=originalPaginationHTML}

    function pushState(q){
        const u=new URL(location.href);
        if(q){u.searchParams.set('clsq',q);u.searchParams.set('clspage',String(searchPage));u.searchParams.set('limit',String(itemsPerPage));if(sortValue)u.searchParams.set('sort_by',sortValue)}
        else{u.searchParams.delete('clsq');u.searchParams.delete('clspage')}
        history.replaceState({clsq:q,clspage:searchPage},'',u.toString())
    }

    function syncSelectsUI($limitSel,$limitNice,$sortSel,$sortNice){
        if($limitSel){$limitSel.value=String(itemsPerPage);if($limitNice)setNiceCurrent($limitNice,String(itemsPerPage))}
        if($sortSel){if(sortValue)$sortSel.value=sortValue;if($sortNice){const li=$sortNice.querySelector(`.nice-list .option[data-value="${sortValue}"]`);const text=li?li.textContent.trim():($sortSel.selectedOptions[0]?.textContent?.trim()||sortValue||'');setNiceCurrent($sortNice,text)}}
    }

    function buildSearchPagiHTML(q,$pagi){
        const totalPages=Math.max(1,Math.ceil(filtered.length/itemsPerPage));
        const cur=Math.min(Math.max(1,searchPage),totalPages);
        const buildHref=(p)=>{const u=new URL(location.href);u.searchParams.set('clsq',q);u.searchParams.set('clspage',String(p));u.searchParams.set('limit',String(itemsPerPage));if(sortValue)u.searchParams.set('sort_by',sortValue);return u.toString()}
        let pages=[1], s=Math.max(2,cur-1), e=Math.min(totalPages-1,cur+1);
        if(s>2)pages.push('…'); for(let p=s;p<=e;p++)pages.push(p); if(e<totalPages-1)pages.push('…'); if(totalPages>1)pages.push(totalPages);
        let html='<ul class="pagination__list overflow-hidden inline-flex flex-wrap justify-center list-unstyled t3" role="list">';
        for(const p of pages){
            if(p==='…'){html+=`<li class="flex"><span class="pagination__item color-scheme-2 gradient">…</span></li>`}
            else if(p===cur){html+=`<li class="flex"><a role="link" aria-disabled="true" class="pagination__item pagination__item--current font-bold full-unstyled-link color-scheme-2 gradient" aria-current="page" aria-label="Page ${p}">${p}</a></li>`}
            else{html+=`<li class="flex"><a href="${buildHref(p)}" data-cls-page="${p}" class="pagination__item full-unstyled-link color-scheme-2 gradient" aria-label="Page ${p}">${p}</a></li>`}
        }
        const next=Math.min(cur+1,totalPages);
        html+=`<li class="flex"><a href="${buildHref(next)}" data-cls-page="${next}" class="pagination__item pagination__item--next pagination__item-arrow full-unstyled-link color-scheme-2 gradient motion-reduce" aria-label="Next page"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M112 184l144 144 144-144" stroke-width="48"></path></svg></a></li>`;
        html+='</ul>';
        $pagi.innerHTML=html
    }

    async function renderPage($ourGrid,$pagi,$count,$container){
        const token=++renderToken;
        const totalPages=Math.max(1,Math.ceil(filtered.length/itemsPerPage));
        if(searchPage>totalPages)searchPage=totalPages;
        if(searchPage<1)searchPage=1;
        const start=(searchPage-1)*itemsPerPage;
        const slice=filtered.slice(start,start+itemsPerPage);
        spinner(true);
        $ourGrid.innerHTML='';
        const cacheKeyPrefix='cls_card_';
        let batchSize=10;
        for(let i=0;i<slice.length;i+=batchSize){
            const part=slice.slice(i,i+batchSize);
            const htmls=await Promise.all(
                part.map(async p=>{
                    const cacheKey=cacheKeyPrefix+p.handle;
                    if(sessionStorage[cacheKey])return sessionStorage[cacheKey];
                    const res=await fetch(`/products/${encodeURIComponent(p.handle)}?view=card`,{headers:{Accept:'text/html'}});
                    const html=res.ok?await res.text():'';
                    sessionStorage[cacheKey]=html;
                    return html;
                })
            );
            if(token!==renderToken)return;
            const tmp=document.createElement('div');
            tmp.innerHTML=htmls.join('');
            const lis=tmp.querySelectorAll('li.grid__item');
            lis.forEach(li=>$ourGrid.appendChild(li));
            await new Promise(r=>requestAnimationFrame(r))
        }
        buildSearchPagiHTML(qs('#cls-input').value.trim(),$pagi);
        updateCount();
        spinner(false);
        const top=$container.getBoundingClientRect().top+window.pageYOffset-20;
        window.scrollTo({top,behavior:'instant'in window?'instant':'smooth'})
    }

    function filterNow($ourGrid,$stdGrid,$pagi,$count){
        const qRaw=qs('#cls-input').value.trim(), q=norm(qRaw);
        if(!q){
            setModeSearch(false,$ourGrid,$stdGrid,$pagi);
            restorePagi($pagi); restoreCount(); pushState('');
            return
        }
        searchPage=1; setModeSearch(true,$ourGrid,$stdGrid,$pagi);
        filtered=all.filter(p=>{
            const t=norm(p.title||''), v=norm(p.vendor||''), d=norm(stripHTML(p.body_html||p.description||''));
            return t.includes(q)||v.includes(q)||d.includes(q)
        });
        applySort(filtered); pushState(qRaw); renderPage($ourGrid,$pagi,$count,qs('#ProductGridContainer')||document.body)
    }

    function onLimit(val,$ourGrid,$stdGrid,$pagi,$count){
        const v=parseInt(val,10); if(!v||isNaN(v))return; itemsPerPage=v; searchPage=1; pushState(qs('#cls-input').value.trim());
        if(qs('#cls-input').value.trim()) renderPage($ourGrid,$pagi,$count,qs('#ProductGridContainer')||document.body);
        else { const u=new URL(location.href); u.searchParams.set('limit',String(itemsPerPage)); location.href=u.toString() }
    }

    function onSort(val,$ourGrid,$stdGrid,$pagi,$count){
        sortValue=val||''; searchPage=1; pushState(qs('#cls-input').value.trim());
        if(qs('#cls-input').value.trim()){ applySort(filtered||[]); renderPage($ourGrid,$pagi,$count,qs('#ProductGridContainer')||document.body) }
        else { const u=new URL(location.href); if(sortValue)u.searchParams.set('sort_by',sortValue); location.href=u.toString() }
    }

    function bind($root){
        const $ourGrid=qs('#cls-grid',$root)||qs('#cls-grid');
        const $stdGrid=qs('#product-grid',$root)||qs('#product-grid');
        let $pagi=qs('[data-pagination]',$root)||qs('.pagination-wrapper',$root)||qs('nav.pagination',$root)||qs('.pagination',$root)||qs('[data-pagination]')||qs('.pagination-wrapper')||qs('nav.pagination')||qs('.pagination');
        const $count=qs('.js-product-count',$root)||qs('.js-product-count');
        const $input=qs('#cls-input',$root)||qs('#cls-input');
        const $limitSel=qs('select[name="limit"]',$root)||qs('select[name="limit"]');
        const $limitNice=$limitSel?$limitSel.parentElement.querySelector('.nice-select'):null;
        const $sortSel=qs('select[name="sort_by"]',$root)||qs('select[name="sort_by"]');
        const $sortNice=$sortSel?$sortSel.parentElement.querySelector('.nice-select'):null;
        if(!$input||!$ourGrid||!$stdGrid||!$pagi)return;

        originalPaginationHTML=$pagi.innerHTML;
        countEls=qsa('.js-product-count',$root);
        if(!countEls.length) countEls=qsa('.js-product-count');
        originalCounts=countEls.map(el=>el.innerHTML);

        const url=new URL(location.href);
        const initialQuery=url.searchParams.get('clsq')||'';
        const initialPage=parseInt(url.searchParams.get('clspage')||'1',10)||1;

        const fromSelect=$limitSel?Number($limitSel.value):NaN;
        const fromNice=$limitNice&&$limitNice.querySelector('.current')?Number($limitNice.querySelector('.current').textContent.trim()):NaN;
        itemsPerPage=Number.isFinite(fromSelect)&&fromSelect>0?fromSelect:Number.isFinite(fromNice)&&fromNice>0?fromNice:itemsPerPage;
        sortValue=url.searchParams.get('sort_by')||($sortSel?$sortSel.value:sortValue);
        syncSelectsUI($limitSel,$limitNice,$sortSel,$sortNice);

        if(!$input.__clsBound){$input.__clsBound=true;$input.addEventListener('input',debounce(()=>filterNow($ourGrid,$stdGrid,$pagi,$count),220))}
        if($limitSel&&!$limitSel.__clsBound){$limitSel.__clsBound=true;$limitSel.addEventListener('change',e=>{if($input.value.trim()){e.preventDefault();e.stopImmediatePropagation()}onLimit(e.target.value,$ourGrid,$stdGrid,$pagi,$count);syncSelectsUI($limitSel,$limitNice,$sortSel,$sortNice)})}
        if($limitNice&&!$limitNice.__clsBound){$limitNice.__clsBound=true;$limitNice.addEventListener('click',e=>{const li=e.target.closest('.option[data-value]');if(!li)return;if($input.value.trim()){e.preventDefault();e.stopImmediatePropagation()}const val=li.getAttribute('data-value');onLimit(val,$ourGrid,$stdGrid,$pagi,$count);setNiceCurrent($limitNice,val)})}
        if($sortSel&&!$sortSel.__clsBound){$sortSel.__clsBound=true;$sortSel.addEventListener('change',e=>{if($input.value.trim()){e.preventDefault();e.stopImmediatePropagation()}onSort(e.target.value,$ourGrid,$stdGrid,$pagi,$count);syncSelectsUI($limitSel,$limitNice,$sortSel,$sortNice)})}
        if($sortNice&&!$sortNice.__clsBound){$sortNice.__clsBound=true;$sortNice.addEventListener('click',e=>{const li=e.target.closest('.option[data-value]');if(!li)return;if($input.value.trim()){e.preventDefault();e.stopImmediatePropagation()}const val=li.getAttribute('data-value');onSort(val,$ourGrid,$stdGrid,$pagi,$count);setNiceCurrent($sortNice,li.textContent.trim())})}
        if(!$pagi.__clsBound){$pagi.__clsBound=true;$pagi.addEventListener('click',e=>{const a=e.target.closest('a[data-cls-page]');if(!a)return;e.preventDefault();const p=parseInt(a.getAttribute('data-cls-page'),10);const total=Math.max(1,Math.ceil(filtered.length/itemsPerPage));if(isNaN(p)||p<1||p>total)return;searchPage=p;pushState($input.value.trim());renderPage($ourGrid,$pagi,$count,qs('#ProductGridContainer')||document.body)})}

        if(initialQuery){$input.value=initialQuery;searchPage=initialPage;filterNow($ourGrid,$stdGrid,$pagi,$count)}
    }

    function observe(){
        const rebinder=()=>bind(document);
        document.addEventListener('facets:updated',rebinder);
        document.addEventListener('shopify:section:load',rebinder);
        const container=qs('#ProductGridContainer')||document.body;
        const mo=new MutationObserver(()=>{const inputNow=qs('#cls-input');const gridNow=qs('#product-grid');if(inputNow&&!inputNow.__clsBound)bind(document);else if(gridNow&&!gridNow.__clsGridBound){gridNow.__clsGridBound=true;bind(document)}});
        mo.observe(container,{childList:true,subtree:true});
        const moRoot=new MutationObserver((muts)=>{if(muts.some(m=>Array.from(m.addedNodes).some(n=>n.nodeType===1&&(n.id==='ProductGridContainer'||n.querySelector?.('#ProductGridContainer'))))){bind(document)}});
        moRoot.observe(document.documentElement,{childList:true,subtree:true})
    }

    function start(){
        bind(document);
        fetchAll();
        observe();
        window.addEventListener('popstate',()=>bind(document))
    }

    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start()
})();
